<div
  *ngIf="status"
  class="status-indicator"
  [style.background-color]="status?.Color"
  ngbTooltip="{{ status?.StatusLabel | translate }}"
></div>
